import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { VendorInfoFormContainer } from './styled'

const ExperienceModal = (props) => {
  const { valueForm, onClose, onSave, vendorIndex, change } = props

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Experience</DialogTitle>
      <DialogContent>
        <VendorInfoFormContainer>
          <form>
            {
              (valueForm.exp || []).map((e, i) => 
                <div className='rowFields'>
                  <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px', marginRight: '10px' }} >{i + 1}. </div>
                  <Field 
                    name={`exp[${i}]`}
                    label=''
                    type={type.text} 
                    component={FieldInput}
                  />
                  <Button color='secondary' onClick={() => {
                    const clone = [...valueForm.exp]
                    clone.splice(i, 1)
                    change('exp', clone)
                  }}>Remove</Button>
                </div>
              )
            }
            <div className='rowFields'>
              <Button color='primary' onClick={() => change('exp', [...valueForm.exp, ''])}>Add</Button>
            </div>
          </form>
        </VendorInfoFormContainer>
      </DialogContent>
      <DialogActions>
        <Button 
          color='primary' 
          onClick={() => {
            onSave(valueForm.exp, vendorIndex)
          }}
        >Save</Button>
        <Button color='secondary' onClick={() => onClose()} >Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const vendorData = props.vendorData || {}
  const valueForm = getFormValues('formShortListExperience')(state) || {}
  var vendExp  = (vendorData.experience || []).length === 0 ? [''] : vendorData.experience || [''] 

  return ({
    valueForm: valueForm,
    initialValues: {
      exp: valueForm.exp || vendExp || ['']
    }
  })
}
  
const mapDispatchToProps = {}

const ExperienceModalForm = reduxForm({
  form: 'formShortListExperience',
})(ExperienceModal)

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceModalForm)